import { render, staticRenderFns } from "./alarm1.vue?vue&type=template&id=21141246&scoped=true"
import script from "./alarm1.vue?vue&type=script&lang=js"
export * from "./alarm1.vue?vue&type=script&lang=js"
import style0 from "./alarm1.vue?vue&type=style&index=0&id=21141246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21141246",
  null
  
)

export default component.exports